export const EXAM_PLAN_GUIDE_ITEMS = [
    {
        id: "notice",
        mission: 0,
        title: "유의사항",
        subtitle: "유의사항",
        sections: [
            {
                type: "reference",
                title: "1. 학년 설정",
                items: [
                    "**모든 미션은 설정한 학년 기준으로 진행되므로 학년 변경 시 주의해 주세요!**",
                    "미션 진행 중 학년 변경 시, 기존 진행 내역이 보이지 않습니다.\n원래 학년으로 재설정하면 기존에 완료한 미션을 이어서 진행할 수 있습니다.\n- 중1에서 미션 완료 후 중2로 변경 → 중2 기준 완료 내역이 없어 처음부터 시작\n- 중1로 학년 재 설정 → 중1 미션 내역 이어서 진행 가능",
                ],
            },
            {
                type: "reference",
                title: "2. 성적 입력 안내",
                items: [
                    "**성적 입력 기간 : 시험대비모드 기간 종료 후, YYYY-MM-dd까지 입력 가능**",
                    "성적 입력 경로 : 마이페이지 > 시험정보 > 시험정보 등록/수정",
                    "보상 지급 기준\n- 전체 미션 완료 후, 화면 상단의 [학년/학기/고사]별 성적 전체 입력 시 보상 지급\n- 실제 점수가 있는 과목만 입력 가능 (허위 정보 입력 시, 보상 지급 불가)",
                    "성적 우수 장학생 신청하기에서 성적 연동 가능",
                ],
            },
            {
                type: "reference",
                title: "3. 별 지급 안내",
                items: [
                    "별 지급 일자 : YYYY-MM-dd",
                    "지급 혜택 : 모든 미션 완료 시, 총 10,000별 지급 (ID당 1회)",
                    {
                        text: "유의 사항\n- 스마트올중학 정회원 대상 (중복 지급 불가)\n- 부정한 방법으로 참여 시, 별 지급 대상에서 제외",
                        displayType: "warning",
                    },
                    {
                        text: "직접 입력한 시험기간이 아닌 시험대비모드 기간 중에 완료한 미션만 인정 됩니다.",
                        displayType: "warning",
                    },
                    {
                        // 날짜는 서버 시험대비모드 기간(MIS_STATUS_TOTAL.START_DT ~ END_DT)으로 치환된다.
                        text: "- 시험대비모드 기간 : YYYY-MM-dd ~ YYYY-MM-dd",
                        displayType: "warning-sub",
                        dateType: "examModePeriod",
                    },
                ],
            },
        ],
    },
    {
        id: "period",
        mission: 1,
        title: "시험기간 · 등록",
        subtitle: "시험기간 **등록하기**",
        sections: [
            {
                title: "시험기간 **등록하기**",
                items: [
                    "나의 시험 기간을 설정하고, 기간 맞춤 서비스를 이용하세요!",
                    "#학기 ##고사 기간을 입력하면 시험대비 첫 미션이 완료됩니다!",
                ],
            },
            {
                type: "path",
                title: "경로",
                items: ["시험대비모드 > 상단 우측 ‘시험기간 등록’ 버튼 클릭", "마이페이지 > 시험정보 등록 / 수정"],
            },
            {
                type: "reference",
                title: "참고",
                items: [
                    "마이페이지를 통해 시험기간을 등록하는 경우,\n화면 상단의 [학년/학기/고사]를 확인하여 정확히 입력해 주세요.",
                    "기간에 맞게 입력해야 별이 지급됩니다.",
                ],
            },
        ],
    },
    {
        id: "lecture",
        mission: 2,
        // {count} 는 서버 미션 정보(MISSION_COUNT)로 치환된다. 값이 없으면 defaultCount 를 쓴다.
        defaultCount: 10,
        title: "시험특강 · {count}강 수강",
        subtitle: "시험특강 **{count}강 수강하기**",
        sections: [
            {
                title: "시험특강 **{count}강 수강하기**",
                items: [
                    "시험특강으로 개념부터 실전 문제풀이까지 마무리 하세요!",
                    "시험특강 강좌 중 ‘{count}강만 완강’해도 미션 성공!",
                ],
            },
            {
                type: "path",
                title: "경로",
                items: [
                    "시험대비모드 > 미션현황 > 시험특강 ‘수강하기’",
                    "SMART 내신 > 시험특강",
                ],
            },
            {
                type: "reference",
                title: "참고",
                items: [
                    "‘응시하기’로 되어 있는 강의의 경우 ‘응시완료’ 시 수강완료",
                    "‘학습시작’,’응시하기’함께 있는 경우 전체 진행 시 수강완료",
                    "‘복습하기’ 수강완료도 포함",
                ],
            },
        ],
    },
    {
        id: "unit-master",
        mission: 3,
        defaultCount: 10,
        title: "단원 마스터 · {count}회 응시",
        subtitle: "단원 마스터 **{count}개 응시하기**",
        sections: [
            {
                title: "단원 마스터 **{count}개 응시하기**",
                items: [
                    "시험 직전, 단원별 TEST를 통해 단원 학습을 마스터 하세요. ",
                    "단원 마스터 TEST ‘{count}개 이상 응시 완료’하면 미션 성공!",
                ],
            },
            {
                type: "path",
                title: "경로",
                items: ["시험대비모드 > 미션현황 > 단원 마스터 ‘응시하기’", "TEST라운지 > 단원 마스터"],
            },
            {
                type: "reference",
                title: "참고",
                items: [
                    "응시 이력이 없는 단원 마스터 TEST ‘응시 완료’ 시 1회 인정",
                    "응시 이력이 있는 단원 마스터 TEST ＇재응시 완료‘ 시 1회 인정",
                    "같은 TEST를 여러 번 반복해도 1회만 인정",
                ],
            },
        ],
    },
    {
        id: "reading",
        mission: 4,
        defaultCount: 5,
        title: "Al 독서실 · {count}회 이용",
        subtitle: "AI 독서실에서 **공부하기**",
        sections: [
            {
                title: "AI 독서실에서 공부하기",
                items: [
                    "AI 독서실 일정을 확인하여 기간 내에 미션에 참여해 보세요.",
                    "#학기 ##고사 운영 기간 내, AI 독서실 {count}회 입장 시 미션 완료!",
                ],
            },
            {
                type: "path",
                title: "경로",
                items: ["시험대비모드 > 미션현황 > AI 독서실 ‘GO’"],
            },
            {
                type: "path-warning",
                title: "주의",
                items: ["다른 경로를 통해 진입 시 미션 완료로 인정되지 않으니 유의해 주세요."],
            },
        ],
    },
    {
        id: "english",
        mission: 5,
        defaultCount: 3,
        title: "AI영어 문법 공략 · {count}회 이용",
        subtitle: "AI영어 문법 **공략하기**",
        sections: [
            {
                title: "AI영어 문법 공략하기",
                items: [
                    "‘시험대비모드’의 학습하기 버튼을 통해 AI영어 문법 공략을 {count}번 이상 학습하면 미션이 완료됩니다.",
                ],
            },
            {
                type: "path",
                title: "경로",
                items: ["시험대비모드 > 미션현황 > MISSION 5 AI영어 문법 공략 ‘GO’"],
            },
            {
                type: "path-warning",
                title: "주의",
                items: ["다른 경로를 통해 진입 시 미션 완료로 인정되지 않으니 유의해 주세요."],
            },
        ],
    },
    {
        id: "math",
        mission: 6,
        defaultCount: 3,
        title: "AI수학 약점 공략 · {count}회 이용",
        subtitle: "AI수학 약점 **공략하기**",
        sections: [
            {
                title: "AI수학 약점 공략하기",
                items: [
                    "‘시험대비모드’의 학습하기 버튼을 통해 AI수학 약점 공략을 {count}번 이상 학습하면 미션이 완료됩니다.",
                ],
            },
            {
                type: "path",
                title: "경로",
                items: ["시험대비모드 > 미션현황 > MISSION 6 AI수학 약점 공략 ‘GO’"],
            },
            {
                type: "path-warning",
                title: "주의",
                items: ["다른 경로를 통해 진입 시 미션 완료로 인정되지 않으니 유의해 주세요."],
            },
        ],
    },
    {
        id: "all-zip",
        mission: 7,
        defaultCount: 5,
        title: "교과서 All-zip · {count}회 이용",
        subtitle: "교과서별 개념 정리! **교과서 All-zip 확인하기**",
        sections: [
            {
                title: "교과서별 개념 정리! 교과서 All-zip 확인하기",
                items: [
                    "‘시험대비모드’의 학습하기 버튼을 통해 교과서 All-zip을 {count}회 이상 학습하면 미션이 완료됩니다.",
                    "동일한 내용을 복습해도 회차 추가 학습으로 인정됩니다.",
                ],
            },
            {
                type: "path",
                title: "경로",
                items: ["시험대비모드 > 미션현황 > MISSION 7 교과서 All-zip ‘GO’"],
            },
            {
                type: "path-warning",
                title: "주의",
                items: ["다른 경로를 통해 진입 시 미션 완료로 인정되지 않으니 유의해 주세요."],
            },
        ],
    },
    {
        id: "score",
        mission: 8,
        title: "최종 성적 · 등록",
        subtitle: "#학기 ##고사 **성적 등록하기**",
        sections: [
            {
                title: "단원 마스터 **10개 응시하기**",
                items: [
                    "최종 미션, 성적 입력은 필수!",
                    "미션 1~7까지 모두 완료 후, [학년/학기/고사]에 맞게 성적을 입력하면 전체 미션이 완료됩니다.",
                ],
            },
            {
                type: "path",
                title: "경로",
                items: ["시험대비모드 > 최종미션 > GO", "마이페이지 > 시험정보 > 시험정보 등록/수정"],
            },
            {
                type: "reference",
                title: "참고",
                items: [
                    "시험대비모드가 끝난 후, 홈 화면의 성적 입력 안내 배너를 통해서도 입력이 가능합니다. ",
                    "실제 점수가 있는 과목만 입력하면 인정됩니다.\n(허위 정보 입력 및 전 과목 0점은 별 지급 대상에서 제외)",
                ],
            },
        ],
    },
];

export const EXAM_PLAN_REVIEWS = [
    {
        mission: "전과목 핵심 시험 특강",
        examPeriod: "2025년도 1학기 기말고사",
        school: "부여중학교",
        grade: "중2",
        studentName: "강신원",
        award: "올백상",
        averageScore: "100",
        review: "시험기간에는 **시험특강으로 시험을 준비하였습니다.**\n자신이 없는 과목들은 반복하여 수강하며 공부하였습니다.",
    },
    {
        mission: "단원 마스터 평가",
        examPeriod: "2025년도 2학기 기말고사",
        school: "시흥중학교",
        grade: "중3",
        studentName: "김한비",
        award: "올백상",
        averageScore: "100",
        review: "시험 기간에는 **단원 마스터로 여러가지 문제들을 풀며 취약한 부분을 보완할 수 있었습니다.** 단원 마스터가 과목 별로 많은 문제들을 쉽게 찾을 수 있도록 해주고 틀린 문제도 바로바로 확인할 수 있어서 좋았습니다.",
    },
    {
        mission: "AI 몰입 독서실",
        examPeriod: "2024년도 2학기 기말고사",
        school: "회룡중학교",
        grade: "중2",
        studentName: "이효경",
        award: "최우수상",
        averageScore: "99",
        review: "스마트올중학에 있는 강의를 다 수강하고 문제들을 전부 풀어본 뒤에는 **매일 8시에 열리는 AI 독서실에서 매일 같은 시간에 체계적으로 공부를 하여** 집중력을 향상시켜 공부 효율을 극대화 하였다.",
    },
    {
        mission: "AI영어 문법 공략",
        examPeriod: "2024년도 2학기 기말고사",
        school: "덕산중학교",
        grade: "중1",
        studentName: "조하윤",
        award: "최우수상",
        averageScore: "98",
        review: "**‘AI 영어’**도 모의고사가 많아 실전감각을 익히는 데 좋았습니다.",
    },
    {
        mission: "AI수학 약점 공략",
        examPeriod: "2023년도 1학기 기말고사",
        school: "효양중학교",
        grade: "중3",
        studentName: "이한솔",
        award: "올백상",
        averageScore: "100",
        review: "수학의 경우에는 **AI 수학에서 세 번 모의고사를 봐서 예상 점수를 산출**해보기도 했습니다.\n스마트올중학의 가장 좋은 점은 같은 내용에 대한 강의와 문제가 많아 여러 번 내가 원하는 만큼 복습할 수 있다는 점입니다.",
    },
    {
        mission: "교과서 All-zip 요약",
        examPeriod: "2025년도 2학기 기말고사",
        school: "수주중학교",
        grade: "중2",
        studentName: "김은호",
        award: "올백상",
        averageScore: 100,
        review: "**교과서 올집을 통해 암기 과목을 마지막으로 한 번 정리**하면서 공부를 했으며, 시험 기간에는 들었던 내신 강의를 한 번씩 더 들어보며 복습하듯이 공부했다.",
    },
    {
        mission: "바로답변 서비스",
        examPeriod: "2023년도 2학기 기말고사",
        school: "덕소중학교",
        grade: "중2",
        studentName: "민세은",
        award: "최우수상",
        averageScore: "98.6",
        review: "스마트올중학에서 나에게 맞는 공부법을 터득해갔다.\n그리고 **시험대비 바로답변서비스를 이용하여 궁금한 점을 바로바로**  알 수 있게 했다.",
    },
];
